// extracted by mini-css-extract-plugin
module.exports = {"title":"SettingSelection_title__2icpk","listSetting":"SettingSelection_listSetting__1fu6I","active":"SettingSelection_active__AfjAR"};